import { APP_NAME } from '../utils/environment';
import { default as module } from './AbstractModule';
import { EVENT as VIMEOPLAYER_EVENT } from './VimeoPlayer';

const MODULE_NAME = 'Next';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

export const EVENT = {
    INVIEW: `inview.${EVENT_NAMESPACE}`
};

export default class extends module {
    constructor(m) {
        super(m);

        this.link = this.$('link')
        this.visual = this.$('visual')
        this.visualOuter = this.$('visualOuter')
        this.visualInner = this.$('visualInner')
        this.video = this.$('video')

        this.$el = $(this.el)
        this.$video = $(this.video)
    }

    init() {
        this.compute()
        this.initTl()

        // Listen for events

        this.mouseEnterBind = () => {
            this.tl.play()
        }
        this.link.addEventListener('mouseenter', this.mouseEnterBind)

        this.mouseLeaveBind = () => {
            this.tl.reverse()
        }
        this.link.addEventListener('mouseleave', this.mouseLeaveBind)

        this.onResizeBind = () => {
            if(!this.resizeTick) {
                this.resizeTick = true

                requestAnimationFrame(() => {
                    this.compute()
                    this.initTl()
                    this.resizeTick = false
                })
            }
        }
        window.addEventListener('resize', this.onResizeBind)

        this.$el.on(EVENT.INVIEW, (e) => {
            this.$video.triggerHandler(Object.assign(e, {
                type: VIMEOPLAYER_EVENT.LAUNCH
            }))
        })
    }

    compute() {
        TweenMax.set([this.visualOuter, this.visualInner, this.visual], { clearProps: 'x,y' })

        this.viewport = {
            width: window.innerWidth,
            height: window.innerHeight,
        }

        this.elBCR = this.el.getBoundingClientRect()
        this.visualBCR = this.visual.getBoundingClientRect()

        this.visualOffset = {
            top: this.visualBCR.top - this.elBCR.top,
            left: this.visualBCR.left - this.elBCR.left
        }
    }

    killTl() {
        if(this.tl && this.tl.kill) this.tl.kill()
    }

    initTl() {
        let visualPosition = {
            y: this.viewport.height/2
        }

        this.killTl()

        TweenMax.set(this.visualOuter, { y: -this.visualOffset.top, x: -this.visualOffset.left })

        if(window.innerWidth >= 1200) {
            this.tl = new TimelineMax({
                onUpdate: () => {
                    TweenMax.set(this.visual, { y: visualPosition.y })
                    TweenMax.set(this.visualInner, { y: -visualPosition.y })
                },
                // repeat: -1
            })
            this.tl.fromTo(visualPosition, .5, { y: this.visualBCR.height*1.1 }, { y: 0, ease: Power4.easeInOut })
            this.tl.progress(0.1)
            this.tl.progress(0)
            this.tl.pause();
        }
    }

    destroy() {
        this.link.removeEventListener('mouseenter', this.mouseEnterBind)
        this.link.removeEventListener('mouseleave', this.mouseLeaveBind)
        window.removeEventListener('resize', this.onResizeBind)

        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
